import { useReveal } from "../hooks/useReveal";
import { Accordion } from "../components/Accordion";
import { FAQS } from "../lib/copy";

export default function Faq() {
  const ref = useReveal();
  const items = FAQS.map((f) => ({ title: f.q, body: f.a }));
  return (
    <section id="faq" ref={ref} className="py-28 md:py-36" data-testid="faq-section">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <p className="section-label mb-8 reveal-up">[008] — FAQ</p>
        <h2 className="reveal-up font-black uppercase mb-14" style={{ fontSize: "clamp(28px, 3.6vw, 48px)", letterSpacing: "-0.02em" }}>
          COMMON QUESTIONS
        </h2>
        <div className="reveal-up">
          <Accordion items={items} testPrefix="faq" />
        </div>
      </div>
    </section>
  );
}
